import { useMemo } from 'react'

import { DatePickerField } from '@avantstay/backoffice-core'

import * as S from '../DatePicker.styles'
import { ViewComponentProps } from '../DatePicker.types'
import { formatDateToString, parseStringToDate } from '../DatePicker.utils'

export const CalendarView = ({ value, onChange }: ViewComponentProps) => {
  const { startDate, endDate } = value ?? {}

  const formattedValue = useMemo(() => {
    if (!startDate || !endDate) return ''

    const formattedStartDate = formatDateToString(startDate)
    const formattedEndDate = formatDateToString(endDate)
    return `${formattedStartDate}_${formattedEndDate}`
  }, [startDate, endDate])

  const handleChange = (newValue: string) => {
    if (!newValue) return

    const [startDate, endDate] = newValue.split('_')
    onChange({
      value: {
        startDate: parseStringToDate(startDate),
        endDate: parseStringToDate(endDate),
      },
      metadata: { preset: undefined },
    })
  }

  return (
    <S.DatePickerContainer>
      <DatePickerField.Small
        pickerClassName={S.calendarViewPickerClassName}
        shouldDisplayInput={false}
        dateValue={formattedValue}
        onChange={handleChange}
      />
    </S.DatePickerContainer>
  )
}
